import React, { useMemo } from 'react';

import { useIssuesMetadata, useSelectedIssueTypes } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RuleFormContext';
import Field from 'src/views/components/Form/Field';

import BaseAdditionalValueSelector from './ActionAdditionalValueSelector/BaseAdditionalValueSelector';
import { createConstStringSource, createJiraFieldsStringSource } from './ActionAdditionalValueSelector/sources';
export const name = 'pd_add_details';
export const label = 'Add incident details';
export const type = 'incident_create';
const emptyArray = [];
const customFields = [
  { name: 'Issue URL', apiName: 'browse_issue_url', schema: { type: 'string' } }
];

export const AdditionalParams = ({ name, values = {}, touched = false, errors = null, onChange, onBlur }) => {
  const issueTypes = useSelectedIssueTypes() || emptyArray;
  const { allFields } = useIssuesMetadata();
  const optionSources = useMemo(() => {
    const relevantFields = allFields.filter(f => f.issueTypeIds.some(id => issueTypes.some(allowedIt => id === allowedIt.id)));
    return [
      createConstStringSource(),
      createJiraFieldsStringSource(relevantFields.concat(customFields)),
    ];
  }, [allFields, issueTypes]);

  return (
    <Field label="Select Fields to add to Incident details">
      <BaseAdditionalValueSelector
        optionSources={optionSources}
        name={`${name}.pd_add_details`}
        value={values.pd_add_details}
        onChange={onChange}
        onBlur={onBlur}
        isMulti
        isClearable
        clearInputOnSelect
        placeholder={'select value(s)...'}
        hasIcons
      />
    </Field>
  );
};
